RivalIQ.apps.Dashboard.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';

    const Deprecation = Marionette.ItemView.mixin({

        template: '#widgetsDashboardDeprecationTemplate'

    });

    const DeprecationWidget = RivalIQ.apps.Dashboard.models.Widget.extend({
        viewMore: false,
        panelView: Deprecation,
        // NOTE setting supportedExportFormats to empty filters the widget out for exports
        supportedExportFormats: []
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.DEPRECATION, DeprecationWidget);
});
